export var TransformationUtil;
(function (TransformationUtil) {
    TransformationUtil.TRANSFORMATION_POINTS_BATCH_SIZE = 10000;
    /**
     * Transforms local Points to WGS84 points in batches
     * @param points Local Points in Cartesian3 array
     * @param site Site
     * @param batchSize batch size default 10000
     * @returns WGS84 Points Cartesian3 Array
     */
    async function transformLocalPointsToWGS84InBatches(points, site, batchSize = TransformationUtil.TRANSFORMATION_POINTS_BATCH_SIZE) {
        const wgs84Points = [];
        for (let index = 0; index < points.length; index += batchSize) {
            const pointDataBatch = points.slice(index, index + batchSize);
            const wgs84PointsBatch = await site.convertPointsToWGS84(pointDataBatch);
            wgs84Points.push(...wgs84PointsBatch);
        }
        return wgs84Points;
    }
    TransformationUtil.transformLocalPointsToWGS84InBatches = transformLocalPointsToWGS84InBatches;
    /**
     * Transforms wgs84 points to local Points in batches
     * @param points PointData array
     * @param site Site
     * @param batchSize batch size default 10000
     * @returns Local Points Cartesian3 Array
     */
    async function transformWGS84PointsToLocalPointsInBatches(points, site, batchSize = TransformationUtil.TRANSFORMATION_POINTS_BATCH_SIZE) {
        const localPoints = [];
        for (let index = 0; index < points.length; index += batchSize) {
            const pointDataBatch = points.slice(index, index + batchSize);
            const localPointsBatch = await site.convertPointsToLocalSpace(pointDataBatch);
            localPoints.push(...localPointsBatch);
        }
        return localPoints;
    }
    TransformationUtil.transformWGS84PointsToLocalPointsInBatches = transformWGS84PointsToLocalPointsInBatches;
})(TransformationUtil || (TransformationUtil = {}));
//# sourceMappingURL=transformation-utils.js.map